// import axios from 'axios';
export const HANDLE_THEME_CHANGE = 'HANDLE_THEME_CHANGE';
export const HANDLE_SENTIMENT_CHANGE = 'HANDLE_SENTIMENT_CHANGE';
export const HANDLE_SOURCES_CHANGE = 'HANDLE_SOURCES_CHANGE';
export const REMOVE_THEME_CHANGE = 'REMOVE_THEME_CHANGE';
export const REMOVE_SENTIMENT_CHANGE = 'REMOVE_SENTIMENT_CHANGE';
export const REMOVE_SOURCES_CHANGE = 'REMOVE_SOURCES_CHANGE';
export const SET_MODAL_FILTERS = 'SET_MODAL_FILTERS';
export const TOGGLE_DEEP_DIVE_MODAL = 'TOGGLE_DEEP_DIVE_MODAL';

export const setModalFilters = (filters) => {
    return {
        type: SET_MODAL_FILTERS,
        payload: filters
    }
}

export const handleSentimentChange = (params) => {
    return {
        type: HANDLE_SENTIMENT_CHANGE,
        payload: params
    }
}

export const removeSentimentChange = () => {
    return {
        type: REMOVE_SENTIMENT_CHANGE
    }
}

export const handleSourcesChange = (params) => {
    return {
        type: HANDLE_SOURCES_CHANGE,
        payload: params
    }
}

export const removeSourcesChange = () => {
    return {
        type: REMOVE_SOURCES_CHANGE
    }
}

export const handleThemeChange = (params) => {
    return {
        type: HANDLE_THEME_CHANGE,
        payload: params
    }
}

export const removeThemeChange = () => {
    return {
        type: REMOVE_THEME_CHANGE
    }
}

export const toggleDeepDiveModal = () => {
    return {
        type: TOGGLE_DEEP_DIVE_MODAL,
    }
}